import qconsole from 'scripts/lib/qconsole';

export default class ClearTeamAssist {
  constructor(context) {
    this.context = context;
  }

  run({ customerId }) {
    if (!customerId) {
      qconsole.error('ClearTeamAssist: must include "customerId". Ignoring.');
      return;
    }

    if (!this.context.stores.customers.has({ id: customerId })) {
      qconsole.log(`ClearTeamAssist: customer [${customerId}] not loaded. Ignoring.`);
      return;
    }

    this.context.gateways.teamAssist.delete({ customerId }).catch(err => {
      qconsole.log(`ClearTeamAssist: failed for customer [${customerId}]`, err);
    });
  }
}
